import { useParams } from 'react-router-dom'
import { CurrentUserContextProvider } from 'context/useCurrentUser'
import { Layout } from 'components/Layout'
import MeetingAssessment from '@legacy/pages/SessionMeetingAssessment/MeetingAssessment'
import { useFeatureToggle } from 'hooks'

export const EditReport = () => {
  const { lessonId } = useParams()
  const meettingId = lessonId
  const arcMosaico = useFeatureToggle('arc-mosaico-project') as boolean
  return (
    <CurrentUserContextProvider>
      <Layout>
        <MeetingAssessment meetingId={meettingId} arcMosaico={arcMosaico} />
      </Layout>
    </CurrentUserContextProvider>
  )
}
